(function () {
  'use strict';

  const sliderSelector = '[data-seo-product-slider]';

  function initialiseSeoProductSlider(slider) {
    if (!slider || slider.dataset.sliderReady === 'true') {
      return;
    }

    slider.dataset.sliderReady = 'true';

    const track = slider.querySelector('[data-slider-track]');
    const previousButton = slider.querySelector('[data-slider-prev]');
    const nextButton = slider.querySelector('[data-slider-next]');
    const progressBar = slider.querySelector('[data-slider-progress]');

    if (!track) {
      return;
    }

    const autoplayEnabled =
      slider.dataset.autoplay === 'true';

    const autoplaySpeed =
      Number.parseInt(slider.dataset.autoplaySpeed, 10) || 3500;

    const reducedMotion =
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let autoplayTimer = null;
    let restartTimer = null;
    let scrollRequest = null;

    let hovered = false;
    let interacting = false;
    let focused = false;


    function getItems() {
      return Array.from(
        track.querySelectorAll('[data-slider-item]')
      );
    }


    function getScrollStep() {
      const items = getItems();

      if (!items.length) {
        return track.clientWidth;
      }

      const firstItem = items[0];

      const trackStyle =
        window.getComputedStyle(track);

      const gap =
        Number.parseFloat(
          trackStyle.columnGap || trackStyle.gap || '0'
        ) || 0;

      return firstItem.getBoundingClientRect().width + gap;
    }


    function getMaxScroll() {
      return Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );
    }


    function isNearEnd() {
      const maxScroll = getMaxScroll();

      return track.scrollLeft >= maxScroll - 8;
    }


    function isNearStart() {
      return track.scrollLeft <= 8;
    }


    function scrollToStart() {
      track.scrollTo({
        left: 0,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }


    function scrollToEnd() {
      track.scrollTo({
        left: getMaxScroll(),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }


    function next() {
      if (isNearEnd()) {
        scrollToStart();
        return;
      }

      track.scrollBy({
        left: getScrollStep(),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }


    function previous() {
      if (isNearStart()) {
        scrollToEnd();
        return;
      }

      track.scrollBy({
        left: -getScrollStep(),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }


    function updateProgress() {
      if (!progressBar) {
        return;
      }

      const maxScroll = getMaxScroll();

      if (maxScroll <= 0) {
        progressBar.style.width = '100%';
        return;
      }

      const percentage =
        (track.scrollLeft / maxScroll) * 100;

      const visiblePercentage =
        Math.max(
          12,
          Math.min(100, percentage)
        );

      progressBar.style.width =
        `${visiblePercentage}%`;
    }


    function shouldAutoplay() {
      return (
        autoplayEnabled &&
        !reducedMotion &&
        !hovered &&
        !interacting &&
        !focused &&
        !document.hidden &&
        getItems().length > 1
      );
    }


    function stopAutoplay() {
      if (autoplayTimer !== null) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }


    function startAutoplay() {
      stopAutoplay();

      if (!shouldAutoplay()) {
        return;
      }

      autoplayTimer = window.setInterval(
        function () {
          next();
        },
        autoplaySpeed
      );
    }


    function restartAutoplay(delay) {
      stopAutoplay();

      if (restartTimer !== null) {
        window.clearTimeout(restartTimer);
      }

      restartTimer = window.setTimeout(
        function () {
          restartTimer = null;
          startAutoplay();
        },
        delay
      );
    }


    if (previousButton) {
      previousButton.addEventListener(
        'click',
        function () {
          stopAutoplay();
          previous();
          restartAutoplay(1400);
        }
      );
    }


    if (nextButton) {
      nextButton.addEventListener(
        'click',
        function () {
          stopAutoplay();
          next();
          restartAutoplay(1400);
        }
      );
    }


    slider.addEventListener(
      'mouseenter',
      function () {
        hovered = true;
        stopAutoplay();
      }
    );


    slider.addEventListener(
      'mouseleave',
      function () {
        hovered = false;
        restartAutoplay(350);
      }
    );


    track.addEventListener(
      'pointerdown',
      function () {
        interacting = true;
        stopAutoplay();
      }
    );


    window.addEventListener(
      'pointerup',
      function () {
        if (!interacting) {
          return;
        }

        interacting = false;
        restartAutoplay(1800);
      }
    );


    track.addEventListener(
      'touchstart',
      function () {
        interacting = true;
        stopAutoplay();
      },
      {
        passive: true
      }
    );


    track.addEventListener(
      'touchend',
      function () {
        interacting = false;
        restartAutoplay(2200);
      },
      {
        passive: true
      }
    );


    track.addEventListener(
      'focusin',
      function () {
        focused = true;
        stopAutoplay();
      }
    );


    track.addEventListener(
      'focusout',
      function () {
        focused = false;
        restartAutoplay(700);
      }
    );


    track.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();

          stopAutoplay();
          next();
          restartAutoplay(1500);
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();

          stopAutoplay();
          previous();
          restartAutoplay(1500);
        }
      }
    );


    track.addEventListener(
      'scroll',
      function () {
        if (scrollRequest !== null) {
          return;
        }

        scrollRequest =
          window.requestAnimationFrame(
            function () {
              updateProgress();
              scrollRequest = null;
            }
          );
      },
      {
        passive: true
      }
    );


    document.addEventListener(
      'visibilitychange',
      function () {
        if (document.hidden) {
          stopAutoplay();
        } else {
          restartAutoplay(300);
        }
      }
    );


    window.addEventListener(
      'resize',
      function () {
        updateProgress();
      },
      {
        passive: true
      }
    );


    updateProgress();
    startAutoplay();
  }


  function initialiseAll(root) {
    const scope = root || document;

    if (
      scope.matches &&
      scope.matches(sliderSelector)
    ) {
      initialiseSeoProductSlider(scope);
    }

    scope
      .querySelectorAll(sliderSelector)
      .forEach(initialiseSeoProductSlider);
  }


  function start() {
    initialiseAll(document);
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialiseAll(event.target);
    }
  );

})();